import { cn } from '@/lib/utils'
import { Icon, type IconName } from './icon'

interface EyebrowProps {
  children: React.ReactNode
  icon?: IconName
  tone?: 'brand' | 'muted'
  className?: string
}

/** Rótulo de seção — mono uppercase (`.eyebrow` do design system). */
export function Eyebrow({ children, icon, tone = 'brand', className }: EyebrowProps) {
  return (
    <div
      className={cn(
        'eyebrow flex items-center gap-2',
        tone === 'brand' ? 'text-brand' : 'text-ink-mute',
        className
      )}
    >
      {icon ? <Icon name={icon} size={13} /> : <span className="h-[5px] w-[5px] shrink-0 rounded-full bg-coral" />}
      {children}
    </div>
  )
}
